export const INPUT_DOCUMENT_EXTRACTED_CONTAINER_IDS = 'extractedContainerIds'
export const INPUT_CONTAINER_ID = 'containerId'
export const INPUT_SHIPMENT_START_DATE = 'shipmentStartDate'

export const INITIAL_FORM_DATA = {
  [INPUT_CONTAINER_ID]: null,
  [INPUT_SHIPMENT_START_DATE]: null,
}
